import React, { Component } from "react";


class Header extends Component {

	render() {
		// const { data } = this.props;

		return (
			<>
				<div>
					{/* <div class="idg-header">
						<h2>Google Review Link & Google Place ID Generator</h2>
						<p>Looking for a simple way to share your Google Business Profile listing with customers?
							With this free tool, you can generate a Google review link for customers, and find
							the Place ID, Ludocid, and FID codes Google uses to identify a business.</p>
					</div> */}
				</div>
			</>
		);
	}
}

export default Header;
